import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockData } from '../mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 px-4 sm:px-6 lg:px-8 bg-black">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl font-bold text-white">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Real experiences from people who trust CCK Possibilities for their transportation needs
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockData.testimonials.map((testimonial) => (
            <Card 
              key={testimonial.id}
              className="border-2 border-gray-800 hover:border-cyan-500 hover:shadow-xl transition-all duration-300 bg-gray-900 relative"
            >
              <CardContent className="pt-6 space-y-4">
                {/* Quote Icon */}
                <div className="absolute top-4 right-4 opacity-10">
                  <Quote className="w-16 h-16 text-cyan-400" />
                </div>

                {/* Stars */}
                <div className="flex space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-300 leading-relaxed italic relative z-10">
                  "{testimonial.text}"
                </p>

                {/* Service Badge */}
                <div className="inline-block bg-gradient-to-r from-cyan-500/20 to-purple-600/20 border border-cyan-500/50 text-cyan-400 text-sm font-medium px-3 py-1 rounded-full">
                  {testimonial.service}
                </div>

                {/* Author */}
                <div className="pt-4 border-t border-gray-800">
                  <div className="font-semibold text-white">{testimonial.name}</div>
                  <div className="text-sm text-gray-400">{testimonial.location}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="mt-16 text-center">
          <p className="text-gray-300 text-lg mb-8">Trusted by patients and healthcare providers across Central Georgia</p>
          <div className="flex flex-wrap justify-center gap-8 items-center opacity-60">
            {mockData.insuranceProviders.map((provider, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="text-gray-400 font-medium hover:text-cyan-400 transition-colors">{provider.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
